import { Power } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconPower(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Power />
    </IconWrapper>
  );
}
